(function($){
    'use strict';

    /**
     * Плагин пагинации
     * @param {Object} [options] - параметры инициализации
     * @param {Number} options.initialPage - номер начальной страницы
     * @param {String} options.pageBtnSelector - селектор кнопки конкретной страницы
     * @param {String} options.prevBtnSelector - селектор кнопки "предыдущая страница"
     * @param {String} options.nextBtnSelector - селектор кнопки "следующая страница"
     * @return {jQuery}
     */
    $.fn.pagination = function (options) {
        const defaults = {
            initialPage: 0,
            pageBtnSelector: '.js-pagination-item',
            prevBtnSelector: '.js-pagination-prev',
            nextBtnSelector: '.js-pagination-next'
        };
        const settings = $.extend({}, defaults, options);
        const $self = $(this);
        let currentPage = settings.initialPage;

        /**
         * Перейти к предыдущей странице
         */
        const prevPage = function () {
            currentPage--;
            $self.trigger('prevPage');
        };

        /**
         * Перейти к следующей странице
         */
        const nextPage = function () {
            currentPage++;
            $self.trigger('nextPage');
        };

        /**
         * Перейти к странице с определенным номером
         * @param {Number} pageNumber - номер страницы, на которую нужно переключиться
         */
        const goToPage = function (pageNumber) {
            currentPage = pageNumber;
            $self.trigger('goToPage', {
                page: pageNumber
            });
        };

        /**
         * Получить номер текущей страницы
         */
        const getCurrentPage = function () {
            return currentPage;
        };

        const init = function () {
            $self.on('click', settings.itemSelector, function () {
                goToPage(parseInt($(this).text(), 10));
            });
            $self.on('click', settings.prevBtnSelector, function () {
                prevPage();
            });
            $self.on('click', settings.nextBtnSelector, function () {
                nextPage();
            });
        };

        init();

        this.prevPage = prevPage;
        this.nextPage = nextPage;
        this.goToPage = goToPage;
        this.getCurrentPage = getCurrentPage;

        return this;
    };
})(jQuery);
